import { apiServiceClient } from '../frameworkClient';

const uploadServiceClient = apiServiceClient(
  process.env.REACT_APP_UPLOAD_URL || 'posale',
);

const endpoints = {
  uploadFile: 'uploadFile',
};

export const uploadFile = async (formData, options) => {
  return uploadServiceClient(endpoints.uploadFile, formData, options);
};

const exports = {
  endpoints,
  uploadFile,
};

export default exports;
